import styled from "styled-components";

export const ProfileUserNameDefaultBox = styled.span`
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    color: ${({theme}) => theme.colors.textMiddleDark};
`;
